import { ILicenceProfile } from "../../api/LicenceProfile";
import EpaCard from "../../leap-components/EpaCard";
import EpaField from "../../leap-components/EpaField";

interface IActiveLicenceDetailsProps {
  licenceProfile: ILicenceProfile;
}

const ActiveLicenceDetails = ({
  licenceProfile,
}: IActiveLicenceDetailsProps) => {
  var bodyElements = (
    <div>
      <EpaField label={"Version"} value={licenceProfile.version} />
      <EpaField label={"Issued"} value={licenceProfile.dateIssued} />
      <EpaField label={"Type"} value={licenceProfile.type} />
      <EpaField label={"Status"} value={licenceProfile.status} />
      <EpaField label={"Sub-status"} value={licenceProfile.subStatus} />
      <EpaField label={"Sector"} value={licenceProfile.sector} />
      <EpaField label={"Major Activity"} value={licenceProfile.majorActivity} />
      <EpaField label={"IED Activity"} value={licenceProfile.iedActivity} />
    </div>
  );

  return (
    <EpaCard title={"Active Authorisation Details"} content={bodyElements} />
  );
};

export default ActiveLicenceDetails;
